import React from "react";
import { ChatHistory } from "../../../../../components";

const Comments = () => {
  return (
    <div className="overflow-auto">
      <ChatHistory />
    </div>
  );
};

export default Comments;
